import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DarkModeProvider } from './components/DarkMode';
import NavigationBar from './components/NavigationBar/NavigationBar';
import Footer from './components/Footer/Footer'; // Import the Footer component
import Homepage from './pages/Homepage';
import About from './pages/About';
import Background from './pages/Background';
import Contact from './pages/Contact'

const App = () => {
  return (
    <div id="app" className="flex flex-col min-h-screen">
      <DarkModeProvider>
        <BrowserRouter>
          <NavigationBar
            links={[
              { to: '/', label: 'Home' },
              { to: '/about', label: 'About' },
              { to: '/background', label: 'Background' },
              { to: '/contact', label: 'Contact' }
            ]}
          />
          <div style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={ <Homepage/> } />
              <Route path="/about" element={ <About/> }/>
              <Route path="/background" element={<Background/> }/>
              <Route path="/contact" element={ <Contact/> }/>
            </Routes>
          </div>
          <Footer />
        </BrowserRouter>
      </DarkModeProvider>
    </div>
  );
};

export default App;
